import React from 'react';
import PropTypes from 'prop-types';
import { Form, Checkbox } from 'semantic-ui-react';
import { Field } from 'redux-form';
import ValidatedFormInput from 'components/ValidatedFormInput';
import { renderRadioGroup, renderCheckboxGrid } from './FormFieldRenderers';

const EligiblePicSection = ({
  availableForSalesValue,
  salesAccessValue,
  territories,
}) => (
  <div style={{ marginTop: '1.5em' }}>
    <h4>Eligible PIC</h4>
    <div
      style={{
        border: '1px solid #ddd',
        borderRadius: '4px',
        padding: '1em',
        marginBottom: '1em',
      }}
    >
      <div style={{ marginBottom: '0.5em' }}>
        <Field
          name="available_for_sales"
          component={({ input }) => (
            <Checkbox
              label="Enable sales access"
              checked={input.value}
              onChange={(e, { checked }) => input.onChange(checked)}
            />
          )}
        />
      </div>
      {availableForSalesValue && (
        <>
          <strong>Sales</strong>
          <Field
            name="sales_access"
            component={renderRadioGroup}
            label=""
            options={[
              {
                value: 'all_regions',
                label: 'All regions (all sales)',
              },
              { value: 'specific_region', label: 'Specific region' },
              {
                value: 'specific_sales_pic',
                label: 'Specific sales PIC',
              },
            ]}
          />
          {salesAccessValue === 'specific_region' && (
            <div
              style={{
                marginTop: '1em',
                padding: '1em',
                backgroundColor: '#f8f9fa',
                borderRadius: '4px',
              }}
            >
              <h5>Select Regions</h5>
              <Field
                name="available_sales_territory_ids"
                component={renderCheckboxGrid}
                label=""
                options={territories}
              />
            </div>
          )}
          {salesAccessValue === 'specific_sales_pic' && (
            <div style={{ marginTop: '1em' }}>
              <Form.Field>
                <label>Sales PIC (comma separated)</label>
                <Field
                  name="available_sales_emails"
                  component={ValidatedFormInput}
                  placeholder="Enter sales PIC names separated by comma"
                />
              </Form.Field>
            </div>
          )}
        </>
      )}
    </div>
    <div style={{ marginTop: '1em' }}>
      <strong>Telesales</strong>
      <div style={{ marginTop: '0.5em' }}>
        <Field
          name="available_for_all_telesales"
          component={({ input }) => (
            <Checkbox
              label="Give access to all telesales"
              checked={input.value}
              onChange={(e, { checked }) => input.onChange(checked)}
            />
          )}
        />
      </div>
    </div>
  </div>
);

EligiblePicSection.propTypes = {
  availableForSalesValue: PropTypes.bool,
  salesAccessValue: PropTypes.string,
  territories: PropTypes.array.isRequired,
};

EligiblePicSection.defaultProps = {
  availableForSalesValue: true,
  salesAccessValue: 'all_regions',
};

export default EligiblePicSection;
